"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadDeliverTypeError = exports.BadTemplateTypeError = exports.BadOrderTypeError = void 0;
class BadOrderTypeError extends Error {
    constructor(message) {
        super(message);
        this.name = 'BadOrderTypeError';
        this.message = message;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
exports.BadOrderTypeError = BadOrderTypeError;
class BadTemplateTypeError extends Error {
    constructor(message) {
        super(message);
        this.name = 'BadTemplateTypeError';
        this.message = message;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
exports.BadTemplateTypeError = BadTemplateTypeError;
class BadDeliverTypeError extends Error {
    constructor(message) {
        super(message);
        this.name = 'BadDeliverTypeError';
        this.message = message;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
exports.BadDeliverTypeError = BadDeliverTypeError;
//# sourceMappingURL=errors.js.map